module.exports = __webpack_public_path__ + "static/media/bulletin-icon.ccc047b0.svg";